module.exports = __webpack_public_path__ + "img/ready.a4c7d80a.jpeg";